import React, {useState} from 'react';
import {Map as MapIcon, Plus} from 'lucide-react';
import {eventMapLimit, setupKey} from '../../utils/eventSetup';
import {addSetupMapSlot} from '../../utils/eventSetupStore';

export default function WorkspaceMapOptions({event, slots, selectedId, onSelect, canEdit}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const key = setupKey(event);
  const atLimit = slots.length >= eventMapLimit(event);

  async function addMap() {
    setBusy(true);
    setError('');
    try {
      onSelect(await addSetupMapSlot({teamId: event.__teamId, key}));
    } catch (err) {
      setError(err.message || 'The map could not be added.');
    } finally {
      setBusy(false);
    }
  }

  return <div className="EventWorkspace__map" role="group" aria-label="Event map">
    <span><MapIcon size={14} aria-hidden="true"/>Maps</span>
    <div className="EventWorkspace__mapOptions">
      {slots.map((slot, index) => <button key={slot.id} type="button" data-map-id={slot.id}
        aria-pressed={selectedId === slot.id} onClick={() => onSelect(slot.id)}>
        Map {index + 1} · {slot.mapName || 'Map TBD'}
      </button>)}
      {canEdit && key && <button type="button" className="EventWorkspace__addMap"
        disabled={busy || atLimit} title={atLimit ? 'Maximum maps for this match format' : undefined} onClick={addMap}>
        <Plus size={14} aria-hidden="true"/>{busy ? 'Adding…' : 'Add map'}
      </button>}
    </div>
    {error && <div role="alert">{error}</div>}
  </div>;
}
